import { StepsBannerErrorConfigModel } from '../../../Common/Misc/models/banner-error-config.model';
import { BriefingStepsEnum } from '../components/BriefingStepsNavigation/briefing-steps-navigation.component';

export enum BriefingBannerErrorTypeEnum {
    BRIEFING_FROMNAME_ERROR = 'BriefingFromNameError',
    BRIEFING_REPLYTO_ERROR = 'BriefingReplyToError',
    BRIEFING_SUBJECT_ERROR = 'BriefingSubjectError',
    BRIEFING_RECIPIENT_ERROR = 'BriefingRecipientError',
    BRIEFING_SCHEDULING_TIME_ERROR = 'BriefingSchedulingTimeError',
    BRIEFING_RSS_FEED_ERROR = 'BriefingRssFeedError',
    BRIEFING_MAILING_LIST_ERROR = 'BriefingMailingListError',
    BRIEFING_DELIVERY_OPTIONS_ERROR = 'BriefingDeliveryOptionsError'
}

export enum BriefingBannerErrorIdEnum {
    fromName = 'fromName_errors',
    replyTo = 'replyTo_errors',
    subject = 'subject_errors',
    recipient = 'recipient_errors',
    scheduling = 'scheduling_time_errors',
    rssFeed = 'rss_feed_errors',
    mailingList = 'mailing_list_errors',
    deliveryOptions = 'delivery_options_errors'
}

export const bannerErrorsMap = new Map<string, StepsBannerErrorConfigModel>([
    [
        BriefingBannerErrorTypeEnum.BRIEFING_FROMNAME_ERROR,
        {errorId: BriefingBannerErrorIdEnum.fromName, label: 'Briefings.input.fromName', tab: BriefingStepsEnum.publishingSettings}
    ],
    [
        BriefingBannerErrorTypeEnum.BRIEFING_REPLYTO_ERROR,
        {errorId: BriefingBannerErrorIdEnum.replyTo, label: 'Briefings.input.replyTo', tab: BriefingStepsEnum.publishingSettings}
    ],
    [
        BriefingBannerErrorTypeEnum.BRIEFING_SUBJECT_ERROR,
        {errorId: BriefingBannerErrorIdEnum.subject, label: 'Briefings.input.subjectLine', tab: BriefingStepsEnum.publishingSettings}
    ],
    [
        BriefingBannerErrorTypeEnum.BRIEFING_RECIPIENT_ERROR,
        {errorId: BriefingBannerErrorIdEnum.recipient, label: 'Briefings.input.recipients', tab: BriefingStepsEnum.publishingSettings}
    ],
    [
        BriefingBannerErrorTypeEnum.BRIEFING_SCHEDULING_TIME_ERROR,
        {errorId: BriefingBannerErrorIdEnum.scheduling, label: 'Briefings.input.schedulingSettings', tab: BriefingStepsEnum.publishingSettings}
    ],
    [
        BriefingBannerErrorTypeEnum.BRIEFING_RSS_FEED_ERROR,
        {errorId: BriefingBannerErrorIdEnum.rssFeed, label: 'Briefings.deliveryOptions.rssFeed', tab: BriefingStepsEnum.publishingSettings}
    ],
    [
        BriefingBannerErrorTypeEnum.BRIEFING_MAILING_LIST_ERROR,
        {errorId: BriefingBannerErrorIdEnum.mailingList, label: 'Briefings.input.mailingLists', tab: BriefingStepsEnum.publishingSettings}
    ],
    [
        BriefingBannerErrorTypeEnum.BRIEFING_DELIVERY_OPTIONS_ERROR,
        {errorId: BriefingBannerErrorIdEnum.deliveryOptions, label: 'Briefings.sidebar.headingDeliveryOptions', tab: BriefingStepsEnum.publishingSettings}
    ]
]);

